/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import { RecordVision, StoreActions } from '@apitable/core';
import { store } from 'pc/store';
import { getStorage, setStorage, StorageMethod, StorageName } from 'pc/utils/storage';

let preIsSideRecordOpen = false;

store.subscribe(() => {
  const state = store.getState();
  const isSideRecordOpen = state.space.isSideRecordOpen;

  //  Opened the side record card
  if (isSideRecordOpen && !preIsSideRecordOpen) {
    // Determine if the left-hand directory tree should be closed
    const sideBarVisible = state.space.sideBarVisible;
    if (sideBarVisible && getStorage(StorageName.RecordVision) == RecordVision.Side && window.innerWidth < 1920) {
      setStorage(StorageName.IsPanelClosed, false, StorageMethod.Set);
      store.dispatch(StoreActions.setSideBarVisible(false));
    }
  }
  preIsSideRecordOpen = isSideRecordOpen;
});
